import {Component} from '@angular/core';
import {Platform, ionicBootstrap} from 'ionic-angular';
import {StatusBar} from 'ionic-native';
import {TabsPage} from './pages/tabs/tabs';
import {DataService} from './data/data.ts';
// import { enableProdMode } from '@angular/core';
import * as firebase from 'firebase';

@Component({
  template: '<ion-nav [root]="rootPage"></ion-nav>',
  providers: [DataService]
})

export class MyApp {

  private rootPage: any;

  constructor(private platform: Platform) {

    const fbConf = {
      apiKey: "AIzaSyAUV1KQeJVrbuCzEcoCAEVrRg8zBRCj4js",
      authDomain: "mystery-night-app.firebaseapp.com",
      databaseURL: "https://mystery-night-app.firebaseio.com",
      storageBucket: "mystery-night-app.appspot.com",
    };
    firebase.initializeApp(fbConf);

    this.rootPage = TabsPage;

    platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      StatusBar.styleDefault();
    });
  }
}
// enableProdMode();
ionicBootstrap(MyApp);
